<template>
  <div>
    <CarouselEditor
      v-show="!$route.query.mobilePreview"
      :jsonData="cards"
      @DATA_UPDATED="previewWeb"
      @PUBLISH_DATA="saveData"
      @MOBILE_PREVIEW="triggerMobilePreview"
    />
    <StudentTestimonialSection
      v-if="Object.keys(cards).length > 0"
      :testimonials="cards"
    />
  </div>
</template>

<script>
import StudentTestimonialSection from "@edyst/shared-components/src/components/StudentTestimonialSection.vue"
import CarouselEditor from "@/components/YoutubeLiveSessionsEditor/CarouselEditor"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    CarouselEditor,
    StudentTestimonialSection,
  },
  data() {
    return {
      cards: [],
    }
  },
  created() {
    let key
    if (this.$route.query.mobilePreview) {
      key = "mobile-preview-testimonial-carousel-data"
    } else {
      key = "testimonial-carousel-data"
    }
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}content/${key}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(res => {
        if (res.data.cards.length === 0) {
          // populate with empty editor field, user will be able to to add new card
          // this.cards = [{ title: "", link: "", thumbnail: "" }]
          console.log("No result is found on the database.")
        } else {
          this.cards = res.data.cards
        }
      })
      .catch(err => {
        this.$noty.error(
          "Something went wrong, please refer to tech team for help",
          {
            layout: "bottomLeft",
            theme: "relax",
            timeout: 2500,
          }
        )
        console.error(err)
      })
  },
  methods: {
    triggerMobilePreview(data) {
      this.postDataToBackend(
        data,
        "mobile-preview-testimonial-carousel-data",
        "Mobile preview is ready."
      ).then(resStatus => {
        if (resStatus) {
          const width = window.screen.availWidth
          const height = window.screen.availHeight
          const top = height / 2 - 320
          const left = width / 2 - 180
          window.open(
            `/update-testimonial-carousel?mobilePreview=true`,
            "_blank",
            `top=${top},left=${left},width=360,height=640`
          )
        }
      })
    },
    previewWeb(data) {
      this.cards = data
    },
    saveData(data) {
      this.postDataToBackend(
        data,
        "testimonial-carousel-data",
        "Successfully saved changes"
      )
    },
    postDataToBackend(data, key, message) {
      const payload = {
        cards: data,
      }
      return this.axios({
        method: "post",
        url: `${siteConfig.siteURL}content/${key}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: payload,
      })
        .then(res => {
          if (res.status) {
            this.$noty.success(message, {
              layout: "bottomLeft",
              theme: "relax",
              timeout: 2000,
            })
            return true
          }
          return false
        })
        .catch(err => {
          this.$noty.error(
            "Failed to save changes, please refer to tech team for help",
            {
              layout: "bottomLeft",
              theme: "relax",
              timeout: 1000,
            }
          )
          console.error("Failed to save changes, server responded with", err)
          return false
        })
    },
  },
}
</script>
